import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Divider, Flex, Image, Input, Button, Select } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { getAllStatusesList } from '../../../../../services/status'
import LoadingData from '../../../../ui/LoadingData'
import { Dropzone } from '@mantine/dropzone'
import { IconArrowNarrowRight, IconTrash } from '@tabler/icons-react'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { useDocumentForm } from './schema/form'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { updateUser, updateUserDocumentVerification } from '../../../../../services/users'
import { getUserDetail } from '../../../../../store/userDetail'
import { useParams } from 'react-router-dom'
import dayjs from 'dayjs'

const UserDocuments = () => {
  const params = useParams()
  const userId = params.id
  const dispatch = useDispatch()
  const { verification, updater } = useSelector((state) => state.user_detail)
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [statusesList, setStatusesList] = useState([])
  const [loadingForm, setLoadingForm] = useState(false)
  const [newDocumentKtp, setNewDocumentKtp] = useState(null)
  const [newDocumentSelfieKtp, setNewDocumentSelfieKtp] = useState(null)

  const form = useDocumentForm()

  const handleSubmitUserDocument = async (formData) => {
    setLoadingForm(true)
    const payload = {
      relationships: [
        {
          attributes: {
            id: Number(formData.verified_status)
          },
          type: "user_verification"
        }
      ]
    }
    try {
      const response = await updateUser(userId, payload)
      if (response.success) {
        if (formData.new_document_ktp !== null && formData.new_document_selfie_ktp !== null) {
          const payload = new FormData()
          payload.append('document', newDocumentKtp)
          payload.append('name', 'ktp')
          payload.append('additional_document', newDocumentSelfieKtp)
          payload.append('additional_document_name', 'selfie')
          const response = await updateUserDocumentVerification(userId, payload)
          if (response.success) {
            setLoadingForm(false)
            dispatch(getUserDetail(userId))
            notificationSuccess('Update User Successfully', 'This data has been updated')
          }
        } else {
          setLoadingForm(false)
          dispatch(getUserDetail(userId))
          notificationSuccess('Update User Successfully', 'This data has been updated')
        }
      }
    } catch (error) {
      setLoadingForm(false)
      let errorDescriptionMessage = 'There is an error while updating user'
      const errorMessage = error?.response?.data?.message
      if (errorMessage) {
        errorDescriptionMessage = errorMessage
      }
      notificationError('Update User Error', errorDescriptionMessage)
    }

  }

  const handleGetStatusList = async () => {
    setLoadingStatus(true)
    const params = {
      sort: '-id',
      'filter[status_type][is]': 6,
    }
    try {
      const response = await getAllStatusesList(params)
      if (response.success) {
        const resData = response.data
        const remapData = resData.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)
          }
        })
        setStatusesList(remapData)
      } else {
        setStatusesList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  useEffect(() => {
    handleGetStatusList()
  }, [])

  useEffect(() => {
    if (verification) {
      handleSetForm(verification)
    }
    // eslint-disable-next-line
  }, [verification])

  const handleSetForm = (value) => {
    const data = {
      new_document_ktp: null,
      recent_document_ktp: value.imageIdentity,
      new_document_selfie_ktp: null,
      recent_document_selfie_ktp: value.imageSelfieIdentity,
      verified_status: value.idStatuses.toString() || '50'
    }

    form.initialize(data)
    form.setValues(data)
  }

  const handleUploadNewDocumentId = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      form.setValues((prev) => ({ ...prev, new_document_ktp: reader.target.result }))
      setNewDocumentKtp(file[0])
    }
  }

  const handleUploadNewDocumentSelfie = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      form.setValues((prev) => ({ ...prev, new_document_selfie_ktp: reader.target.result }))
      setNewDocumentSelfieKtp(file[0])
    }
  }

  const handleErrorFile = (formData, file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      form.setFieldValue(formData, 'The maximum allowed image size is 2mb')
      notificationError('Upload Image Error', 'The maximum allowed image size is 2mb')
    }
  }

  const handlingScrolledError = (error) => {
      const errorField = Object.keys(error)[0]
      if (errorField) {
        const inputNode = form.getInputNode(errorField)
        if (inputNode) {
          inputNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }
    }

  const loadDocumentId = () => {
    if (form.getValues().new_document_ktp === null) {
      return (
        <Box ta='center' py={10}>
          <Flex justify='center'>
            <Image
              src={NoImage}
              height={195}
              w={500}
              fit='contain'
            />
          </Flex>
          <Box>
            <Text fz={12} c='blue.9'>Upload ID Photo Here</Text>
            <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
          </Box>
        </Box>
      )
    } else {
      return (
        <Image
          src={form.getValues().new_document_ktp}
          height={250}
          w={500}
          fit='contain'
        />
      )
    }
  }


  const loadDocumentSelfie = () => {
    if (form.getValues().new_document_selfie_ktp === null) {
      return (
        <Box ta='center' py={10}>
          <Flex justify='center'>
            <Image
              src={NoImage}
              height={195}
              w={500}
              fit='contain'
            />
          </Flex>
          <Box>
            <Text fz={12} c='blue.9'>Upload Selfie ID Photo Here</Text>
            <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
          </Box>
        </Box>
      )
    } else {
      return (
        <Image
          src={form.getValues().new_document_selfie_ktp}
          height={250}
          w={500}
          fit='contain'
        />
      )
    }
  }

  const loadForm = () => {
    return (
      <Box>
        <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
          <Text fw={500}>
            Submitted ID Photo
          </Text>

          <Divider my='xs' />

          <Flex align='center' gap='md'>
            <Box>
              <Input.Wrapper
                label='Upload New ID Photo'
                size='xs'
                error={form.errors.new_document_ktp}
              >
                <Paper withBorder shadow='xs' radius='md'>
                  <Dropzone
                    accept={[
                      'image/png',
                      'image/jpeg',
                      'image/gif',
                    ]}
                    onDrop={(files) => handleUploadNewDocumentId(files)}
                    onReject={(files) => handleErrorFile('new_document_ktp', files)}
                    maxSize={2000000}
                    style={{ border: 'none', backgroundColor: '#f4f4f4', padding: 0 }}
                  >
                  <Box ta='center'>
                    { loadDocumentId() }
                    </Box>
                  </Dropzone>
                </Paper>
              </Input.Wrapper>
              <Box mt={20} ta='center'>
                <Button
                  size='xs'
                  leftSection={<IconTrash size={14} />} 
                  variant="filled"
                  color='red'
                  onClick={() => [form.setValues((prev) => ({ ...prev, new_document_ktp: null })), setNewDocumentKtp(null)]} 
                  disabled={form.getValues().new_document_ktp === null}>Remove Photo</Button>
              </Box>
            </Box>

            <IconArrowNarrowRight size={30} />

            <Box mb={50}>
              <Input.Wrapper
                label='Current ID Photo'
                size='xs'
              >
                <Paper withBorder shadow='xs' radius='md'>
                  <Image
                    src={form.getValues().recent_document_ktp || NoImage}
                    height={250}
                    w={500}
                    fit={form.getValues().recent_document_ktp === null ? 'cover' : 'contain'}
                  />
                </Paper>
              </Input.Wrapper>
            </Box>
          </Flex>
        </Paper>

        <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
          <Text fw={500}>
            Submitted Selfie with ID
          </Text>

          <Divider my='xs' />

          <Flex align='center' gap='md'>
            <Box>
              <Input.Wrapper
                label='Upload New Selfie with ID Photo'
                size='xs'
                error={form.errors.new_document_selfie_ktp}
              >
                <Paper withBorder shadow='xs' radius='md'>
                  <Dropzone
                    accept={[
                      'image/png',
                      'image/jpeg',
                      'image/gif',
                    ]}
                    onDrop={(files) => handleUploadNewDocumentSelfie(files)}
                    onReject={(files) => handleErrorFile('new_document_selfie_ktp', files)}
                    maxSize={2000000}
                    style={{ border: 'none', backgroundColor: '#f4f4f4', padding: 0 }}
                  >
                  <Box ta='center'>
                    { loadDocumentSelfie() }
                    </Box>
                  </Dropzone>
                </Paper>
              </Input.Wrapper>
              <Box mt={20} ta='center'>
                <Button
                  size='xs'
                  leftSection={<IconTrash size={14} />}
                  variant="filled"
                  color='red'
                  onClick={() => [form.setValues((prev) => ({ ...prev, new_document_selfie_ktp: null })), setNewDocumentSelfieKtp(null)]}
                  disabled={form.getValues().new_document_selfie_ktp === null}>Remove Photo</Button>
              </Box>
            </Box>

            <IconArrowNarrowRight size={30} />

            <Box mb={50}>
              <Input.Wrapper
                label='Current Selfie with ID Photo'
                size='xs'
              >
                <Paper withBorder shadow='xs' radius='md'>
                  <Image
                    src={form.getValues().recent_document_selfie_ktp || NoImage}
                    height={250}
                    w={500}
                    fit={form.getValues().recent_document_selfie_ktp === null ? 'cover' : 'contain'}
                  />
                </Paper>
              </Input.Wrapper>
            </Box>
          </Flex>
        </Paper>

        <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
          <Text fw={500}>
            Verification
          </Text>

          <Divider my='xs' />

          <Select
            size='xs'
            data={statusesList}
            label='Verified Identity Status'
            placeholder='Select Status'
            allowDeselect={false}
            key={form.key('verified_status')}
            {...form.getInputProps('verified_status')}
          />
        </Paper>

        <Box mt={20}>
          <Flex justify='space-between' align='flex-end'>
            <Box ml={4}>
              <Flex align='center' mb={4}>
                <Text fz={12} c='gray.6'>Updated By: </Text>
              </Flex>
              <Box>
                <Text fz={14} fw='500' lineClamp={2}>{updater ? updater.nameUpdater : 'No User'}</Text>
                <Text fz={10} c='gray.6'>{dayjs(updater.updatedAt).format('DD/MMMM/YYYY')} - { dayjs(updater.updatedAt).format('HH:mm:ss')}</Text>
              </Box>
            </Box>
            <Button
              size='xs'
              loading={loadingForm}
              variant="filled"
              onClick={form.onSubmit((value) => { 
                handleSubmitUserDocument(value) 
              }, (error) => {
                handlingScrolledError(error) 
              })}
            >
              Update
            </Button>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingStatus ? <LoadingData /> : loadForm()}
    </Box>
  )
}

export default UserDocuments